import { ContactUs, CopyrightFooter, DataGrid } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import { String } from 'aws-sdk/clients/marketplacemetering';
import { render } from 'enzyme';
import * as React from 'react';
import { Col, Glyphicon, Panel, Row, Tab, Table, Tabs } from 'react-bootstrap';
import { Redirect } from 'react-router';
import { IFoundationDetails } from './interfaces';

interface IFoundationDetailsState {
  ein: string;
  data: IFoundationDetails[];
  fileName: string;
  pageNumber: number;
  foundationName: string;
  yearEnd: string;
}

export class FoundationMark50Details extends Container<{}, IFoundationDetailsState> {
  static irsFilingKey = 'FoundationMark50DetailsKey';

  mapAppStateToContainerState(appState: IAppState) {
    return {
      ein: null,
      data: [],
      fileName: '',
      pageNumber: null,
      foundationName: '',
      yearEnd: '',
    };
  }

  componentWillMount() {
    const search = this.getLocationSearch();
    this.setState({ ein: search.ein }, () => {
      this.loadDetails();
    });
    this.downloadFile = this.downloadFile.bind(this);
  }

  loadDetails() {
    const { ein } = this.state;

    const assetLevelRequest = {
      method: 'POST',
      body: JSON.stringify({ action: 'foundationmark50', state: '', assetLevel: 0, monthNumber: 12, ein }),
    };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark50details', assetLevelRequest)
      .then((resp) => resp.json())
      .then((json) => {
        // tslint:disable-next-line:no-console
        this.setState({ data: json });
      });
  }

  renderCurrency(num: number, currency: boolean = false, pageNumber: number = null, fileName: string = null, yearEnd: string = '') {
    let formattedNumber = parseFloat((num / 1000000.0).toFixed(1)).toLocaleString();
    if (formattedNumber.indexOf('.') === -1) {
      formattedNumber += '.0';
    }
    if (currency) {
      formattedNumber = '$' + formattedNumber;
    }
    if (num == 0) {
      formattedNumber = '-';
    }
    if (pageNumber && pageNumber > 0) {
      return (
        <a
          onClick={() => {
            this.setState({ fileName, pageNumber, yearEnd }, this.downloadFile);
          }}
        >
          {formattedNumber}
        </a>
      );
    }
    return formattedNumber;
  }

  setFileNameandPage() {
    const { fileName, pageNumber, ein } = this.state;
    let { foundationName, yearEnd } = this.state;
    if ((foundationName === '' || !foundationName) && this.state.data && this.state.data.length > 0) {
      foundationName = this.state.data[this.state.data.length - 1].name;
    }
    window.localStorage.setItem(
      FoundationMark50Details.irsFilingKey,
      JSON.stringify({ fileName, pageNumber, foundationName, yearEnd, ein }),
    );
  }

  downloadFile() {
    this.setFileNameandPage();
    location.hash = 'irs-filing';
  }

  renderStars(numberOfStars: number) {
    const html = [];
    for (let i = 0; i < numberOfStars; i++) {
      html.push(<i className="fa fa-star" aria-hidden="true" />);
    }
    return html;
  }

  render() {
    const { data } = this.state;

    if (!data || data.length == 0) {
      return (
        <div className="container">
          <h4 style={{ padding: '20px' }}>
            Loading...&nbsp;<i className="fa fa-cog fa-spin"></i>
          </h4>
        </div>
      );
    }

    return (
      <div className="container" style={{ paddingTop: '30px' }}>
        <Row>
          <Col xs={12}>
            <span style={{ float: 'right', padding: '10px' }}>
              <a className="btn btn-primary" href="#/foundationmark15">
                Back
              </a>
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={5}>
            <Panel style={{ minHeight: '400px' }}>
              <div className="panel-heading" style={{ backgroundColor: '#1C5184', color: '#fff' }}>
                <h6 className="panel-title">Foundation Details</h6>
              </div>
              <div className="panel-body" style={{ padding: '0px' }}>
                <ul className="list-group">
                  <li className="list-group-item" style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
                    {data[4].name}
                  </li>
                  <li className="list-group-item">
                    <b>Address:</b>
                    <br />
                    {data[4].streetAddress}
                    <br />
                    {data[4].city}, {data[4].state}
                  </li>
                  <li className="list-group-item">
                    <b>Website:</b> <a href={data[4].website}>{data[4].website}</a>
                  </li>
                  <li className="list-group-item">
                    <b>Phone:</b> {data[4].foundationPhone}
                  </li>
                  <li className="list-group-item">
                    <b>Comments:</b>
                    {data[4].comment}
                  </li>
                </ul>
              </div>
            </Panel>
          </Col>
          <Col xs={12} md={7}>
            <Panel>
              <div className="panel-heading" style={{ backgroundColor: '#1C5184', color: '#fff' }}>
                <h6 className="panel-title">FoundationMark Estimated Performance - {data[4].yearEnd}</h6>
              </div>
              <div className="panel-body" style={{ padding: '10px' }}>
                <Row>
                  <Col xs={12} md={4} style={{ textAlign: 'center' }}>
                    <Panel style={{ minHeight: '250px', backgroundColor: '#2D5CA0', color: '#fff' }}>
                      <div className="panel-body">
                        <span className="detailsHeader">1-Year Performance</span>
                        <br />
                        <span className="detailsPercent">{(data[4].performance1Year * 100.0).toFixed(1)}%</span>
                        <br />
                        <br />
                        <span className="detailsStar">{this.renderStars(data[4].oneYearStarRatingAll)}</span>
                      </div>
                    </Panel>
                  </Col>
                  <Col xs={12} md={4} style={{ textAlign: 'center' }}>
                    <Panel style={{ minHeight: '250px', backgroundColor: '#2D5CA0', color: '#fff' }}>
                      <div className="panel-body">
                        <span className="detailsHeader">3-Year Performance</span>
                        <br />
                        <span className="detailsPercent">{(data[4].performance3Year * 100.0).toFixed(1)}%</span>
                        <br />
                        <br />
                        <span className="detailsStar">{this.renderStars(data[4].threeYearStarRatingAll)}</span>
                      </div>
                    </Panel>
                  </Col>
                  <Col xs={12} md={4} style={{ textAlign: 'center' }}>
                    <Panel style={{ minHeight: '250px', backgroundColor: '#2D5CA0', color: '#fff' }}>
                      <div className="panel-body">
                        <span className="detailsHeader">5-Year Performance</span>
                        <br />
                        <span className="detailsPercent">{(data[4].performance5Year * 100.0).toFixed(1)}%</span>
                        <br />
                        <br />
                        <span className="detailsStar">{this.renderStars(data[4].fiveYearStarRatingAll)}</span>
                      </div>
                    </Panel>
                  </Col>
                </Row>
                <section style={{ fontSize: '12px' }}>
                  <b>Disclaimer:</b> The FoundationMark performance estimates are approximations of investment returns as calculated using
                  publicly available data. No representations are made as to the accuracy of such estimates. Actual performance may be
                  materially different.{' '}
                </section>
              </div>
            </Panel>
          </Col>
        </Row>
        <Panel>
          <div className="panel-heading" style={{ backgroundColor: '#1C5184', color: '#fff' }}>
            <h6 className="panel-title">Financial Statements</h6>
          </div>
          <div className="panel-body" style={{ padding: '0px' }}>
            <section style={{ paddingTop: '20px' }}>
              {data[0].name} - Condensed Balance Sheet {data[0].yearEnd} - {data[4].yearEnd}
            </section>
            <section style={{ backgroundColor: '#fff' }}>
              <Table className="table table-responsive">
                <thead>
                  <tr>
                    <th>$ in millions</th>
                    <th></th>
                    <th></th>
                    <th className="text-right">{data[0].yearEnd}</th>
                    <th className="text-right">{data[1].yearEnd}</th>
                    <th className="text-right">{data[2].yearEnd}</th>
                    <th className="text-right">{data[3].yearEnd}</th>
                    <th className="text-right">{data[4].yearEnd}</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: '14px' }}>
                  <tr>
                    <td style={{ fontWeight: 'bold' }}>Fair Market Value of Total Assets</td>
                    <td></td>
                    <td></td>
                    <td style={{ fontWeight: 'bold' }} className="text-right">
                      {this.renderCurrency(data[0].fmvTotal, true)}
                    </td>
                    <td style={{ fontWeight: 'bold' }} className="text-right">
                      {this.renderCurrency(data[1].fmvTotal, true)}
                    </td>
                    <td style={{ fontWeight: 'bold' }} className="text-right">
                      {this.renderCurrency(data[2].fmvTotal, true)}
                    </td>
                    <td style={{ fontWeight: 'bold' }} className="text-right">
                      {this.renderCurrency(data[3].fmvTotal, true)}
                    </td>
                    <td style={{ fontWeight: 'bold' }} className="text-right">
                      {this.renderCurrency(data[4].fmvTotal, true)}
                    </td>
                  </tr>
                  <tr>
                    <td>Asset Class</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Cash &amp; Equivalents</td>
                    <td></td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[0].cash + data[0].savings,
                        false,
                        data[0].cashPage,
                        data[0].pdfReportFilename,
                        data[0].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[1].cash + data[1].savings,
                        false,
                        data[1].cashPage,
                        data[1].pdfReportFilename,
                        data[1].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[2].cash + data[2].savings,
                        false,
                        data[2].cashPage,
                        data[2].pdfReportFilename,
                        data[2].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[3].cash + data[3].savings,
                        false,
                        data[3].cashPage,
                        data[3].pdfReportFilename,
                        data[3].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[4].cash + data[4].savings,
                        false,
                        data[4].cashPage,
                        data[4].pdfReportFilename,
                        data[4].yearEnd,
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Fixed Income</td>
                    <td></td>
                    <td className="text-right">
                      {this.renderCurrency(data[0].governmentBonds + data[0].corporateBonds + data[0].mortgageBonds)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[1].governmentBonds + data[1].corporateBonds + data[1].mortgageBonds)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[2].governmentBonds + data[2].corporateBonds + data[2].mortgageBonds)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[3].governmentBonds + data[3].corporateBonds + data[3].mortgageBonds)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[4].governmentBonds + data[4].corporateBonds + data[4].mortgageBonds)}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Equities</td>
                    <td></td>
                    <td className="text-right">
                      {this.renderCurrency(data[0].equities, false, data[0].stockPage, data[0].pdfReportFilename, data[0].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[1].equities, false, data[1].stockPage, data[1].pdfReportFilename, data[1].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[2].equities, false, data[2].stockPage, data[2].pdfReportFilename, data[2].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[3].equities, false, data[3].stockPage, data[3].pdfReportFilename, data[3].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[4].equities, false, data[4].stockPage, data[4].pdfReportFilename, data[4].yearEnd)}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Investments - Other</td>
                    <td></td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[0].investmentProperty + data[0].investmentsOther,
                        false,
                        data[0].otherInvPage,
                        data[0].pdfReportFilename,
                        data[0].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[1].investmentProperty + data[1].investmentsOther,
                        false,
                        data[1].otherInvPage,
                        data[1].pdfReportFilename,
                        data[1].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[2].investmentProperty + data[2].investmentsOther,
                        false,
                        data[2].otherInvPage,
                        data[2].pdfReportFilename,
                        data[2].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[3].investmentProperty + data[3].investmentsOther,
                        false,
                        data[3].otherInvPage,
                        data[3].pdfReportFilename,
                        data[3].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[4].investmentProperty + data[4].investmentsOther,
                        false,
                        data[4].otherInvPage,
                        data[4].pdfReportFilename,
                        data[4].yearEnd,
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Other Assets</td>
                    <td></td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[0].pledgesReceivable +
                          data[0].grantsReceivable +
                          data[0].receivablesFromOfficers +
                          data[0].otherNotesAndLoansReceivable +
                          data[0].inventoriesForSaleOrUse +
                          data[0].prepaidExpenses +
                          data[0].plantPropertyEquipment +
                          data[0].otherAssets,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[1].pledgesReceivable +
                          data[1].grantsReceivable +
                          data[1].receivablesFromOfficers +
                          data[1].otherNotesAndLoansReceivable +
                          data[1].inventoriesForSaleOrUse +
                          data[1].prepaidExpenses +
                          data[1].plantPropertyEquipment +
                          data[1].otherAssets,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[2].pledgesReceivable +
                          data[2].grantsReceivable +
                          data[2].receivablesFromOfficers +
                          data[2].otherNotesAndLoansReceivable +
                          data[2].inventoriesForSaleOrUse +
                          data[2].prepaidExpenses +
                          data[2].plantPropertyEquipment +
                          data[2].otherAssets,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[3].pledgesReceivable +
                          data[3].grantsReceivable +
                          data[3].receivablesFromOfficers +
                          data[3].otherNotesAndLoansReceivable +
                          data[3].inventoriesForSaleOrUse +
                          data[3].prepaidExpenses +
                          data[3].plantPropertyEquipment +
                          data[3].otherAssets,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[4].pledgesReceivable +
                          data[4].grantsReceivable +
                          data[4].receivablesFromOfficers +
                          data[4].otherNotesAndLoansReceivable +
                          data[4].inventoriesForSaleOrUse +
                          data[4].prepaidExpenses +
                          data[4].plantPropertyEquipment +
                          data[4].otherAssets,
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>Total Assets</td>
                    <td className="text-right">{this.renderCurrency(data[0].totalAssets, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].totalAssets, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].totalAssets, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].totalAssets, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].totalAssets, true)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Total Liabilities</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].totalLiabilities)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].totalLiabilities)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].totalLiabilities)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].totalLiabilities)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].totalLiabilities)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>Net Assets</td>
                    <td className="text-right">{this.renderCurrency(data[0].totalAssets - data[0].totalLiabilities, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].totalAssets - data[1].totalLiabilities, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].totalAssets - data[2].totalLiabilities, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].totalAssets - data[3].totalLiabilities, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].totalAssets - data[4].totalLiabilities, true)}</td>
                  </tr>
                </tbody>
              </Table>
            </section>
            <section style={{ paddingTop: '20px' }}>
              {data[0].name} - Condensed Revenue and Expense Statements FY {data[0].fiscalYear} - FY {data[4].fiscalYear}
            </section>
            <section style={{ backgroundColor: '#fff' }}>
              <Table>
                <thead>
                  <tr style={{ textAlign: 'center' }}>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th className="text-right">FY {data[0].fiscalYear}</th>
                    <th className="text-right">FY {data[1].fiscalYear}</th>
                    <th className="text-right">FY {data[2].fiscalYear}</th>
                    <th className="text-right">FY {data[3].fiscalYear}</th>
                    <th className="text-right">FY {data[4].fiscalYear}</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: '14px' }}>
                  <tr>
                    <td>Revenue</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Incoming Contributions</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].incomingContributions, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].incomingContributions, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].incomingContributions, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].incomingContributions, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].incomingContributions, true)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Interest &amp; Dividends</td>
                    <td></td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[0].interest + data[0].dividends,
                        false,
                        data[0].dividendPage,
                        data[0].pdfReportFilename,
                        data[0].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[1].interest + data[1].dividends,
                        false,
                        data[1].dividendPage,
                        data[1].pdfReportFilename,
                        data[1].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[2].interest + data[2].dividends,
                        false,
                        data[2].dividendPage,
                        data[2].pdfReportFilename,
                        data[2].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[3].interest + data[3].dividends,
                        false,
                        data[3].dividendPage,
                        data[3].pdfReportFilename,
                        data[3].yearEnd,
                      )}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(
                        data[4].interest + data[4].dividends,
                        false,
                        data[4].dividendPage,
                        data[4].pdfReportFilename,
                        data[4].yearEnd,
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Gross Rental Income</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].grossRent)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].grossRent)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].grossRent)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].grossRent)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].grossRent)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Capital Gains (Loss)</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].capGain)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].capGain)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].capGain)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].capGain)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].capGain)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Other Income</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].profit + data[0].otherIncome)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].profit + data[1].otherIncome)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].profit + data[2].otherIncome)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].profit + data[3].otherIncome)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].profit + data[4].otherIncome)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>Total Revenue</td>
                    <td className="text-right">{this.renderCurrency(data[0].totalRevenue, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].totalRevenue, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].totalRevenue, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].totalRevenue, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].totalRevenue, true)}</td>
                  </tr>
                  <tr>
                    <td>Expenses</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Trustee &amp; Officers Comp.</td>
                    <td></td>
                    <td className="text-right">
                      {this.renderCurrency(data[0].trusteeComp, false, data[0].trusteePage, data[0].pdfReportFilename, data[0].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[1].trusteeComp, false, data[1].trusteePage, data[1].pdfReportFilename, data[1].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[2].trusteeComp, false, data[2].trusteePage, data[2].pdfReportFilename, data[2].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[3].trusteeComp, false, data[3].trusteePage, data[3].pdfReportFilename, data[3].yearEnd)}
                    </td>
                    <td className="text-right">
                      {this.renderCurrency(data[4].trusteeComp, false, data[4].trusteePage, data[4].pdfReportFilename, data[4].yearEnd)}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Salaries, Wages, Benefits</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].wages + data[0].pensions)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].wages + data[1].pensions)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].wages + data[2].pensions)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].wages + data[3].pensions)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].wages + data[4].pensions)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Legal &amp; Accounting</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].legal + data[0].accounting)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].legal + data[1].accounting)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].legal + data[2].accounting)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].legal + data[3].accounting)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].legal + data[4].accounting)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Other Professional Fees</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].opf)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].opf)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].opf)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].opf)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].opf)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Interest</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].interestPaid)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].interestPaid)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].interestPaid)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].interestPaid)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].interestPaid)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Taxes</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].taxes)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].taxes)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].taxes)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].taxes)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].taxes)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Occupancy, Depr., and Depletion</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].depreciation + data[0].occupancy)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].depreciation + data[1].occupancy)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].depreciation + data[2].occupancy)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].depreciation + data[3].occupancy)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].depreciation + data[4].occupancy)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Travel, Printing, and Publications</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].travel + data[0].printing)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].travel + data[1].printing)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].travel + data[2].printing)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].travel + data[3].printing)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].travel + data[4].printing)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Other Expenses</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].otherExpenses)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].otherExpenses)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].otherExpenses)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].otherExpenses)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].otherExpenses)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Total Operating and Administrative Expenses</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].expenses, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].expenses, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].expenses, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].expenses, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].expenses, true)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Contributions, Gifts, and Grants Paid</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].disbursements, true)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Total Expenses and Disbursements</td>
                    <td></td>
                    <td className="text-right">{this.renderCurrency(data[0].expenses + data[0].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[1].expenses + data[1].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[2].expenses + data[2].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[3].expenses + data[3].disbursements, true)}</td>
                    <td className="text-right">{this.renderCurrency(data[4].expenses + data[4].disbursements, true)}</td>
                  </tr>
                </tbody>
              </Table>
            </section>
          </div>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/FoundationMark50Details/index.tsx